// document.addEventListener("DOMContentLoaded", () => {

//   const radios = document.querySelectorAll(
//     'input[name="properties[Personalisation]"]'
//   );

//   if (!radios.length) return;

//   const box = document.getElementById("personalise-name-box");

//   radios.forEach((radio) => {

//     radio.addEventListener("change", function () {

//       if (this.value === "With Name") {
//         box.style.display = "block";
//       } else {
//         box.style.display = "none";

//         const input = document.getElementById("custom-name");

//         if (input) input.value = "";
//       }

//     });

//   });

// });

document.addEventListener("DOMContentLoaded", () => {

  const radios = document.querySelectorAll(
    'input[name="properties[Personalisation]"]'
  );

  if (!radios.length) return;

  const box = document.getElementById("personalise-name-box");
  const NAME_CHARGE_VARIANT_ID = 43581841506371;
  let added = false;

  radios.forEach((radio) => {
    radio.addEventListener("change", function () {

      if (this.value === "With Name") {

        if (box) box.style.display = "block";
        if (added) return;

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: NAME_CHARGE_VARIANT_ID,
            quantity: 1
          })
        })
        .then(res => {
          if (!res.ok) throw new Error("Add failed");
          return res.json();
        })
        .then(() => {
          added = true;
          return fetch("/cart.js");
        })
        .then(res => res.json())
        .then(cart => {

          // ✅ Ecomus refresh events
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          document.dispatchEvent(new CustomEvent("on:cart:add", {
            detail: { cart: cart }
          }));

          // ✅ Cart count update
          document.querySelectorAll(
            ".cart-count, .js-cart-count, [data-cart-count], .count-bubble"
          ).forEach(el => el.textContent = cart.item_count);

        })
        .catch(err => console.error("Error:", err));

      } else {

        if (box) box.style.display = "none";
        const input = document.getElementById("custom-name");
        if (input) input.value = "";

        if (!added) return;

        fetch("/cart.js")
          .then(res => res.json())
          .then(cart => {
            const lineIndex = cart.items.findIndex(
              i => String(i.variant_id) === String(NAME_CHARGE_VARIANT_ID)
            );
            if (lineIndex === -1) return;

            return fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                line: lineIndex + 1,
                quantity: 0
              })
            });
          })
          .then(res => res && res.json())
          .then(() => {
            added = false;
            document.dispatchEvent(new CustomEvent("cart:refresh"));
          })
          .catch(err => console.error("Remove failed:", err));
      }

    });
  });

});

